<section class="list-landing-skeleton-container">
  <div *ngIf="platform === PlatformEnum.desktop" class="banner-container">
    <ion-skeleton-text class="banner" animated></ion-skeleton-text>
    <div class="text">{{ 'i18n.inventory.inventoryTitle' | translate }}</div>
  </div>
  <div class="main-container">
    <ion-row class="tile-container">
      <ion-col size="5.625"
        ><ion-skeleton-text class="tile" animated></ion-skeleton-text
      ></ion-col>
      <ion-col size="5.625"
        ><ion-skeleton-text class="tile" animated></ion-skeleton-text
      ></ion-col>
    </ion-row>
    <div class="topper">
      <div *ngIf="platform === PlatformEnum.tablet" class="title-container">
        <ion-skeleton-text class="title" animated></ion-skeleton-text>
        <ion-skeleton-text class="actions" animated></ion-skeleton-text>
      </div>
      <ion-skeleton-text
        *ngIf="platform !== PlatformEnum.tablet"
        class="title"
        animated
      ></ion-skeleton-text>
      <ion-skeleton-text class="sort" animated></ion-skeleton-text>
    </div>
    <ion-skeleton-text class="item" animated></ion-skeleton-text>
    <ion-skeleton-text class="item" animated></ion-skeleton-text>
    <ion-skeleton-text class="item" animated></ion-skeleton-text>
    <ion-skeleton-text class="item" animated></ion-skeleton-text>
    <ion-skeleton-text class="item" animated></ion-skeleton-text>
    <ion-skeleton-text class="item" animated></ion-skeleton-text>
    <ion-skeleton-text class="item" animated></ion-skeleton-text>
    <ion-skeleton-text class="item" animated></ion-skeleton-text>
  </div>
</section>
